import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { FiArrowRight, FiGift } from "react-icons/fi";
import { useLanguage } from "../../../contexts/LanguageContext";
import { REF_MAX_PERCENT, REF_MAX_POINTS } from "../../../lib/referral";

const Card = styled.aside`
  position: relative;
  display: grid;
  gap: 12px;
  align-content: start;
  padding: 16px;
  border-radius: 16px;
  overflow: hidden;
  background:
    radial-gradient(130% 120% at 100% 0%, ${(p) => p.theme.colors.primary}2e 0%, transparent 60%),
    ${(p) => p.theme.colors.surface};
  box-shadow: inset 0 0 0 1px ${(p) => p.theme.colors.primary}33;
  .icon {
    width: 36px;
    height: 36px;
    display: grid;
    place-items: center;
    border-radius: 10px;
    background: ${(p) => p.theme.colors.primarySoft};
    color: ${(p) => p.theme.colors.primary};
  }
  h2 {
    font-size: 16px;
    line-height: 22px;
    font-weight: 650;
    letter-spacing: -0.01em;
  }
  p {
    font-size: 14px;
    line-height: 20px;
    color: ${(p) => p.theme.colors.textSecondary};
  }
  a.cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 44px;
    padding: 0 16px;
    border-radius: 12px;
    font-size: 15px;
    font-weight: 600;
    background: ${(p) => p.theme.colors.primary};
    color: ${(p) => p.theme.colors.onPrimary};
    transition: background ${(p) => p.theme.motion.fast};
    &:hover {
      background: ${(p) => p.theme.colors.primaryHover};
    }
  }
`;

/** Плашка под блоком друзей: ведёт на страницу «Рефералка». */
export default function ReferralBanner() {
  const { t } = useLanguage();
  return (
    <Card aria-labelledby="ref-banner">
      <span className="icon">
        <FiGift size={18} aria-hidden="true" />
      </span>
      <div style={{ display: "grid", gap: 4 }}>
        <h2 id="ref-banner">{t("ref.banner.title")}</h2>
        <p>{t("ref.banner.text", { n: REF_MAX_POINTS, pct: REF_MAX_PERCENT })}</p>
      </div>
      <Link className="cta" to="/referral">
        {t("ref.banner.cta")}
        <FiArrowRight aria-hidden="true" />
      </Link>
    </Card>
  );
}
